import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { Dates } from "./GetAllConsultants";
export type ConsultantsDTO = {
    id:string;
    name:string;
    consulantDate:Dates
    email:string;
    phone:string;
    description:string;
    status:string;
    createdAt:string;
    updatedAt:string;
    consultant: {
        name:string;
    }
};

type getConsultantsResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: ConsultantsDTO[];
};
export const ConsultantBookingById = async (id: string): Promise<getConsultantsResponse> => {
  try {
    const response = await axios.get(`/consultant-booking/byConsultantId/${id}`);
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
